module.exports = __webpack_public_path__ + "0508cb20fd06367185f9d4be7594ccaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/Stina_goya_scarf_hat.jpg
// module id = 168
// module chunks = 0